import $ from 'jquery';

$( '.c-timeline__item__year' ).on( 'click', function( event ) {
	const $this = $( this ).closest('.c-timeline__item');

	if ( $this.hasClass( 'c-timeline__item--is-visible' ) ) {
		$this.removeClass( 'c-timeline__item--is-visible' );
	} else {
		$this.closest( '.c-timeline' ).find( '.c-timeline__item' ).removeClass( 'c-timeline__item--is-visible' );
		$this.toggleClass( 'c-timeline__item--is-visible' );
	}
} );
